'use strict';

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // UI


var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Text = _ref.Text,
      Button = _ref.Button;

  var CtaArea = function (_Component) {
    _inherits(CtaArea, _Component);

    function CtaArea() {
      _classCallCheck(this, CtaArea);

      return _possibleConstructorReturn(this, (CtaArea.__proto__ || Object.getPrototypeOf(CtaArea)).apply(this, arguments));
    }

    _createClass(CtaArea, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            messageText = _props.messageText,
            onCtaClick = _props.onCtaClick,
            buttonProps = _props.buttonProps;
        var messageButtonClass = (0, _classnames2['default'])(theme.message, theme.flexend);
        return _react2['default'].createElement('div', {
          className: theme.actions
        }, _react2['default'].createElement('div', {
          className: this.animationClass
        }, _react2['default'].createElement('div', {
          className: theme.message
        }, _react2['default'].createElement(Text, {
          color: 'grey',
          size: 'tiny',
          align: 'center'
        }, messageText)), _react2['default'].createElement('div', {
          className: messageButtonClass
        }, _react2['default'].createElement(Button, {
          text: buttonProps.text,
          bgColor: buttonProps.bgColor,
          color: buttonProps.textColor,
          link: buttonProps.link,
          clickHandler: onCtaClick,
          size: 'small',
          noWrap: true
        }))));
      }
    }, {
      key: 'animationClass',
      get: function get() {
        var _cn;

        var _props2 = this.props,
            theme = _props2.theme,
            ctaVisible = _props2.ctaVisible,
            ctaVisibleForced = _props2.ctaVisibleForced;
        return (0, _classnames2['default'])(theme.animationContainer, (_cn = {}, _defineProperty(_cn, theme.ctaInvisible, !ctaVisible), _defineProperty(_cn, theme.ctaVisible, ctaVisible), _defineProperty(_cn, theme.forcedVisible, ctaVisibleForced), _cn));
      }
    }]);

    return CtaArea;
  }(_react.Component);

  CtaArea.displayName = identifier;
  CtaArea.propTypes = {
    theme: _propTypes2['default'].object.isRequired,
    messageText: _propTypes2['default'].string.isRequired,
    buttonProps: _propTypes2['default'].object.isRequired,
    onCtaClick: _propTypes2['default'].func.isRequired,
    ctaVisible: _propTypes2['default'].bool.isRequired,
    ctaVisibleForced: _propTypes2['default'].bool
  };
  return CtaArea;
};

exports['default'] = factory;